/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { CodeSnippet, InlineNotification } from '@carbon/react';

import { deploymentTypes, modes } from 'App/Pages/Diagram/features/deployment/utils';

export default function ActionFailed({ deploymentType, mode, failureMessage }) {
  const getTitle = () => {
    if (mode === modes.DEPLOY) {
      if (deploymentType === deploymentTypes.DIAGRAM) {
        return 'Diagram could not be deployed';
      } else if (deploymentType === deploymentTypes.PROCESS_APPLICATION) {
        return 'The application failed to deploy';
      }
    } else if (mode === modes.EXECUTE) {
      if (deploymentType === deploymentTypes.DIAGRAM) {
        return 'Instance could not be started';
      } else if (deploymentType === deploymentTypes.PROCESS_APPLICATION) {
        return 'The application failed to execute';
      }
    }

    return '';
  };

  return (
    <>
      <InlineNotification title={getTitle()} hideCloseButton lowContrast />
      <CodeSnippet data-test="errors-list" wrapText type="multi" copyButtonDescription="Copy">
        {failureMessage}
      </CodeSnippet>
    </>
  );
}
